import Vue from 'vue'
import store from './index.js'
import { isSet } from '../helpers/helpers'

function resetState(componentName, section) {
	switch (componentName) {
	case 'QuickSearch':
		resetQuickSearch();
		break;
	case 'CompanySearch':
		resetCompanySearch(section);
		break;
	}
}

// QuickSearch.vue
let resetQuickSearch = () => {
	Vue.set(store.state.quicksearchmodule, 'results', []);
	Vue.set(store.state.quicksearchmodule, 'resultCount', 0);
	Vue.set(store.state.quicksearchmodule, 'searchTerm', '');
	Vue.set(store.state.quicksearchmodule, 'take', 50);
	Vue.set(store.state.quicksearchmodule, 'skip', 0);
};

// CompanySearch.vue
let resetCompanySearch = (section) => {
	if (isSet(section)) {
		let promise = ((section) => {
			switch (section) {
			case 'companySearch':
				return resetCompanySearchTopBox();
			case 'industry':
				return resetCompanySearchIndustry();
			case 'financials':
				return resetCompanySearchFinancials();
			case 'buyerTraits':
				return resetCompanySearchBuyerTraits();
			case 'numbers':
				return resetCompanySearchNumbers();
			case 'ForNonLimitedOnly':
				return resetForNonLimitedOnly();
				case 'bqprofile':
				return resetBQProfile();
			}
		})(section);

		promise.then(() => {
			console.log("Section clear(is set)");
			store.state.companysearchmodule.savePagePromise = store.dispatch('companysearchmodule/saveCompanySearch');
			store.state.companysearchmodule.savePagePromise.then(() => {
				store.dispatch('companysearchmodule/getCompanyResultCount');
			});
		});
	} else {
		let promises = [];
		promises.push(resetCompanySearchTopBox());
		promises.push(resetCompanySearchIndustry());
		promises.push(resetCompanySearchFinancials());
		promises.push(resetCompanySearchBuyerTraits());
		promises.push(resetCompanySearchNumbers());
		promises.push(resetBQProfile());
		Promise.all(promises).then((values) => {
			console.log("Section clear(is not set)");
			Vue.set(store.state.companysearchmodule.search, 'companySearchId', null);
			Vue.set(store.state.companysearchmodule.search, 'excludeCompanyNumbers', []);
			Vue.set(store.state.companysearchmodule.search, 'excludeSubsidiariesAndIntermediates', false);
			Vue.set(store.state.companysearchmodule.search, 'excludeFiles', []);
			Vue.set(store.state.companysearchmodule.search, 'resultCount', 0); 
			Vue.set(store.state.companysearchmodule.search, 'recalculatingCount', false);
			Vue.set(store.state.companysearchmodule.search, 'excludePLCs', false);
			Vue.set(store.state.companysearchmodule.search, 'excludePrivateInvestors', false);
			Vue.set(store.state.companysearchmodule.search, 'excludePrivateEquityHouses', false);
			store.state.companysearchmodule.savePagePromise = store.dispatch('companysearchmodule/saveCompanySearch');
		});
	}
};

let resetCompanySearchTopBox = () => {
	return new Promise((resolve, reject) => {
		Vue.set(store.state.companysearchmodule.search, 'companyName', null);
		Vue.set(store.state.companysearchmodule.search, 'website', null);
		Vue.set(store.state.companysearchmodule.search, 'companyNumber', null);
		Vue.set(store.state.companysearchmodule.search, 'regions', null);
		Vue.set(store.state.companysearchmodule.search, 'postcodes', null);
		Vue.set(store.state.companysearchmodule.search, 'countries', null);
		Vue.set(store.state.companysearchmodule.search, 'nonLimitedOnly', false);
		Vue.set(store.state.companysearchmodule.search, 'excludeBlocked', true);
		resolve(true);
	});
};

let resetCompanySearchIndustry = () => {
	return new Promise((resolve, reject) => {
		Vue.set(store.state.companysearchmodule.search, 'includedKeywords', []);
		Vue.set(store.state.companysearchmodule.search, 'excludedKeywords', []);
		Vue.set(store.state.companysearchmodule.search, 'sectors', []);
		Vue.set(store.state.companysearchmodule.search, 'sicCodes', []);
		Vue.set(store.state.companysearchmodule.search, 'includeKeywords', false);
		Vue.set(store.state.companysearchmodule.search, 'includeAcquisitionKeywords', false);
		Vue.set(store.state.companysearchmodule.search, 'includeOverviewKeywords', false);
		Vue.set(store.state.companysearchmodule.search, 'keywordIncludeAll', false);
		Vue.set(store.state.companysearchmodule.search, 'keywordSearchAll', false);
		resolve(true);
	});
};

let resetBQProfile = () => {
	return new Promise((resolve, reject) => {
		Vue.set(store.state.companysearchmodule.search, 'bqProfileIncludeKeywords', []);
		Vue.set(store.state.companysearchmodule.search, 'bqProfileKeywordIncludeAll', false);
		console.log("Reset BQProfile")
		resolve(true);
	})
}

let resetCompanySearchFinancials = () => {
	return new Promise((resolve, reject) => {
		Vue.set(store.state.companysearchmodule.search, 'minTurnover', null);
		Vue.set(store.state.companysearchmodule.search, 'maxTurnover', null);
		Vue.set(store.state.companysearchmodule.search, 'mustIncludeTurnover', false);
		Vue.set(store.state.companysearchmodule.search, 'minEBITDA', null);
		Vue.set(store.state.companysearchmodule.search, 'maxEBITDA', null);
		Vue.set(store.state.companysearchmodule.search, 'mustIncludeEBITDA', false);
		Vue.set(store.state.companysearchmodule.search, 'minShareholdersFunds', null);
		Vue.set(store.state.companysearchmodule.search, 'maxShareholdersFunds', null);
		Vue.set(store.state.companysearchmodule.search, 'mustIncludeShareholdersFunds', false);
		Vue.set(store.state.companysearchmodule.search, 'minCash', null);
		Vue.set(store.state.companysearchmodule.search, 'maxCash', null);
		Vue.set(store.state.companysearchmodule.search, 'mustIncludeCash', false);
		Vue.set(store.state.companysearchmodule.search, 'minEmployees', null);
		Vue.set(store.state.companysearchmodule.search, 'maxEmployees', null);
		Vue.set(store.state.companysearchmodule.search, 'mustIncludeEmployees', false);
		Vue.set(store.state.companysearchmodule.search, 'includeProjectionsCVS', false);
		Vue.set(store.state.companysearchmodule.search, 'includeTurnoverEstimates', false);
		resolve(true);
	});
};

let resetCompanySearchBuyerTraits = () => {
	return new Promise((resolve, reject) => {
		Vue.set(store.state.companysearchmodule.search, 'increasingCash', false);
		Vue.set(store.state.companysearchmodule.search, 'turnoverGrowth', false);
		Vue.set(store.state.companysearchmodule.search, 'signedNDAOnly', false);
		Vue.set(store.state.companysearchmodule.search, 'excludeSignedNDA', false);
		Vue.set(store.state.companysearchmodule.search, 'increasingTotalAssets', false);
		Vue.set(store.state.companysearchmodule.search, 'profitGrowth', false);
		Vue.set(store.state.companysearchmodule.search, 'profitMarginGrowth', false);
		Vue.set(store.state.companysearchmodule.search, 'employeeGrowth', false);
		Vue.set(store.state.companysearchmodule.search, 'plcOwned', false);
		Vue.set(store.state.companysearchmodule.search, 'plcHouse', false);
		Vue.set(store.state.companysearchmodule.search, 'mustIncludeBuyerTraits', false);
		Vue.set(store.state.companysearchmodule.search, 'hasAcquired', false);
		Vue.set(store.state.companysearchmodule.search, 'beenAcquired', false);
		resolve(true);
	});
};

let resetForNonLimitedOnly = () => {
	return new Promise((resolve, reject) => {
		Vue.set(store.state.companysearchmodule.search, 'minTurnover', null);
		Vue.set(store.state.companysearchmodule.search, 'maxTurnover', null);
		Vue.set(store.state.companysearchmodule.search, 'mustIncludeTurnover', false);
		Vue.set(store.state.companysearchmodule.search, 'minEBITDA', null);
		Vue.set(store.state.companysearchmodule.search, 'maxEBITDA', null);
		Vue.set(store.state.companysearchmodule.search, 'mustIncludeEBITDA', false);
		Vue.set(store.state.companysearchmodule.search, 'minShareholdersFunds', null);
		Vue.set(store.state.companysearchmodule.search, 'maxShareholdersFunds', null);
		Vue.set(store.state.companysearchmodule.search, 'mustIncludeShareholdersFunds', false);
		Vue.set(store.state.companysearchmodule.search, 'minCash', null);
		Vue.set(store.state.companysearchmodule.search, 'maxCash', null);
		Vue.set(store.state.companysearchmodule.search, 'mustIncludeCash', false);
		Vue.set(store.state.companysearchmodule.search, 'minEmployees', null);
		Vue.set(store.state.companysearchmodule.search, 'maxEmployees', null);
		Vue.set(store.state.companysearchmodule.search, 'mustIncludeEmployees', false);
		Vue.set(store.state.companysearchmodule.search, 'includeProjectionsCVS', false);
		Vue.set(store.state.companysearchmodule.search, 'includeTurnoverEstimates', false);
		Vue.set(store.state.companysearchmodule.search, 'increasingCash', false);
		Vue.set(store.state.companysearchmodule.search, 'turnoverGrowth', false);
		Vue.set(store.state.companysearchmodule.search, 'signedNDAOnly', false);
		Vue.set(store.state.companysearchmodule.search, 'excludeSignedNDA', false);
		Vue.set(store.state.companysearchmodule.search, 'increasingTotalAssets', false);
		Vue.set(store.state.companysearchmodule.search, 'profitGrowth', false);
		Vue.set(store.state.companysearchmodule.search, 'profitMarginGrowth', false);
		Vue.set(store.state.companysearchmodule.search, 'employeeGrowth', false);
		Vue.set(store.state.companysearchmodule.search, 'plcOwned', false);
		Vue.set(store.state.companysearchmodule.search, 'plcHouse', false);
		Vue.set(store.state.companysearchmodule.search, 'mustIncludeBuyerTraits', false);
		Vue.set(store.state.companysearchmodule.search, 'hasAcquired', false);
		Vue.set(store.state.companysearchmodule.search, 'beenAcquired', false);
		resolve(true);
	});
};

let resetCompanySearchNumbers = () => {
	return new Promise((resolve, reject) => {
		Vue.set(store.state.companysearchmodule.search, 'includeCompanyNumbers', []);
		Vue.set(store.state.companysearchmodule.search, 'includeVendorReferences', []);
		Vue.set(store.state.companysearchmodule.search, 'files', []);
		Vue.set(store.state.companysearchmodule.search, 'includeCompanyNames', []);
		Vue.set(store.state.companysearchmodule.search, 'mustIncludeCompanyNumbers', false);
		resolve(true);
	});
};

export { resetState };
